import {Box, Menu, MenuItem, styled, TextField} from '@mui/material'
import dayjs from 'dayjs'
import {useState} from 'react'
import PropTypes from 'prop-types'
import {CopyToClipboardDiv, StyledCopyEmailButton} from '../../Common/CopyContent/CopyContentStyles'
import IosShareIcon from '@mui/icons-material/IosShare'
import Mailto from 'react-mailto-link'
import theme from '../../../themes'
import FileSaver from 'file-saver'
import {disclaimer} from '../CopyContent/CopyContentIndex'

export const StyledTextField = styled(TextField)(({theme}) => ({
  width: '100%',
  background: theme.palette.common.white,
  borderRadius: '4px'
}))

export const StyledMenu = styled(Menu)(({theme}) => ({
  '& .MuiPaper-root': {
    backgroundColor: theme.palette.common.grey,
    minWidth: '150px'
  },
  '& .MuiMenuItem-root': {
    ':hover': {
      backgroundColor: theme.palette.common.grey2
    }
  }
}))

const menuOptions = [{label: 'Text', key: 'text'}]

const ExportContent = ({content}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const openExportMenu = Boolean(anchorEl)

  const handleExportBtnClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleExportMenuClose = () => {
    setAnchorEl(null)
  }

  const extractSubjectLine = (text) => {
    if (!text) return ''
    const subjectIndex = text.indexOf('Subject:')
    const emailContentIndex = text.indexOf('Email Content:')
    if (subjectIndex === -1 || emailContentIndex === -1) return ''
    return text.substring(subjectIndex + 'Subject:'.length, emailContentIndex).trim()
  }

  const extractEmailBody = (text) => {
    if (!text) return text
    const emailContentIndex = text.indexOf('Email Content:')
    if (emailContentIndex === -1) return text
    return text.substring(emailContentIndex + 'Email Content:'.length).trim()
  }

  const downloadText = async () => {
    const filename = `ExportedContent_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.txt`
    const blob = new Blob([disclaimer + '\n\n' + content], {type: 'text/plain'})
    FileSaver.saveAs(blob, filename)
  }

  const handleExportClick = (option) => {
    if (option === 'text') {
      downloadText()
    }
  }

  return (
    <Box>
      <CopyToClipboardDiv>
        <StyledCopyEmailButton variant="outlined" onClick={handleExportBtnClick} startIcon={<IosShareIcon />}>
          {'Export Content'}
        </StyledCopyEmailButton>
        <StyledMenu
          anchorEl={anchorEl}
          open={openExportMenu}
          onClose={handleExportMenuClose}
          onClick={handleExportMenuClose}
        >
          {menuOptions.map((option) => (
            <MenuItem key={option.key} onClick={() => handleExportClick(option.key)}>
              {option.label}
            </MenuItem>
          ))}
          <MenuItem key={'mail'}>
            <Mailto
              style={{color: theme.palette.common.white, textDecoration: 'none'}}
              email=""
              obfuscated={true}
              headers={{
                body: disclaimer + '\n\n' + extractEmailBody(content),
                subject: extractSubjectLine(content)
              }}
            >
              Email
            </Mailto>
          </MenuItem>
        </StyledMenu>
      </CopyToClipboardDiv>
    </Box>
  )
}

ExportContent.propTypes = {
  content: PropTypes.string
}

export default ExportContent
